import { createSlice } from "@reduxjs/toolkit";
import * as approvalService from "services/approvalService";
import { ListViewOption } from "core/components/listToggle/listToggleControl";
import { WipFilterModel } from "core/models/WipFilterModel";
import { logger } from "utils/logger";
import * as styleService from "services/styleService";
import { MediaFilterModel } from "core/models";
import ResultSet from "core/models/ResultSet";
import { updateCaptureItems } from "utils/helper";
import { updateCapture } from "services/approvalService";

const wipSlice = createSlice({
  name: "wipSlice",
  initialState: {
    wips: new ResultSet(),
    selectedWip: null,
    selectedStyles: [],
    displayPrefs: { mediaDisplayType: ListViewOption.GRID },
    // The list's column choices (column id -> shown); null means the
    // column defaults (meta.show).
    listColumns: null,
    wipFilter: { ...new WipFilterModel(), groupBy: "Dept" },
    styleFilter: { ...new WipFilterModel() },
    styleMediaFilter: { ...new MediaFilterModel() },
    styles: new ResultSet(),
    report: new ResultSet(),
    productionWipList: new ResultSet(),
    productionWipFilter: { ...new WipFilterModel(), groupBy: "" },

    postProductionWipList: new ResultSet(),
    postProductionWipFilter: { ...new WipFilterModel(), groupBy: "" },

    wipSearchCursor: null,

    selectedStyle: null,
    // standard props
    error: null,
    success: null,
    loading: false,
    action: null,
  },
  reducers: {
    setListColumns(state, action) {
      state.listColumns = action.payload ? { ...action.payload } : null;
    },
    setDisplayPrefs(state, action) {
      state.displayPrefs = { ...action.payload };
    },
    selectStyle(state, action) {
      logger.log("Setting Style: ", action.payload);
      state.selectedStyle = action.payload ? { ...action.payload } : null;
    },
    selectStyles(state, action) {
      logger.log("setting selected wips", action.payload);
      state.selectedStyles = action.payload ? [...action.payload] : [];
    },
    setWipFilter(state, action) {
      logger.log("Setting Wip: ", action.payload);
      state.wipFilter = action.payload ? { ...action.payload } : null;
    },
    setProductionWipFilter(state, action) {
      logger.log("Setting Production Wip Filter: ", action.payload);
      state.productionWipFilter = action.payload ? { ...action.payload } : null;
    },
    setStyleFilter(state, action) {
      logger.log("Setting Style Filter: ", action.payload);
      state.styleFilter = action.payload ? { ...action.payload } : null;
    },
    setStyleMediaFilter(state, action) {
      logger.log("Setting Style Filter: ", action.payload);
      state.styleMediaFilter = action.payload ? { ...action.payload } : null;
    },

    setPostProductionWipFilter(state, action) {
      logger.log("Setting Post Production Wip Filter: ", action.payload);
      state.postProductionWipFilter = action.payload
        ? { ...action.payload }
        : null;
    },

    setError(state, action) {
      state.error = action.payload;
    },
    //////////////////////
    //
    // GET STYLES
    //
    //////////////////////
    getWipsStart(state, action) {
      state.success = null;
      state.error = null;
    },
    getWipsSuccess(state, action) {
      logger.log("getWipSuccess : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Get Wips Success" };

      state.wips = {
        ...state.wips,
        [action.payload.id]: {
          data: action.payload.data,
          timestamp: action.payload.timestamp,
        },
      };
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getWipsFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    //////////////////////
    //
    // GET STYLES
    //
    //////////////////////
    getStylesStart(state, action) {
      state.success = null;
      state.error = null;
    },
    getScheduleSuccess(state, action) {
      logger.log("getSchudule : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Get Styles Success" };

      const { items = [], cursor, concatItems, complete } = action.payload.data;

      const existingItems = concatItems && Array.isArray(state.styles.data) ? [...state.styles.data] : [];
      const mergedItems = concatItems ? existingItems.concat(items) : [...items];

      state.wipSearchCursor = cursor ?? null;
      state.styles = {
        ...action.payload,
        data: mergedItems,
        complete: complete ?? false,
      };

      state.error = null;
    },
    getScheduleFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
      state.loading = false
    },

    //////////////////////
    //
    // GET APPROVAL SELECTS
    //
    //////////////////////
    getApprovalSelectsSuccess(state, action) {
      logger.log("getApprovalSelects : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Get Approval Selects Success",
      };

      // state.styles = [...action.payload];
      state.productionWipList = {
        ...state.styles,
        ...action.payload,
      };

      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getApprovalSelectsFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    getApprovalStyleCapturesSuccess(state, action) {
      logger.log("getApprovalSelects : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Get Approval Selects Success",
      };

      // state.styles = [...action.payload];
      // state.styles = {
      //   ...state.styles,
      //   ...action.payload,
      // };

      state.selectedStyle = {
        ...state.selectedStyle,
        assets: action.payload.data,
      };

      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getApprovalStyleCapturesFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    setSessionCapturesSuccess(state, action) {
      logger.log(action.type, " : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Captures successfully updated",
      };

      // update the captures
      const captures = [
        ...updateCaptureItems(state.selectedStyle.assets, action.payload),
      ];
      state.selectedStyle = { ...state.selectedStyle, assets: captures };
      state.error = null;
    },

    //////////////////////
    //
    // GET POST PRODUCTION TASKS
    //
    //////////////////////
    getPostProdTasksSuccess(state, action) {
      logger.log("getPostProductionTasks : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Get Post Production Tasks Success",
      };

      // state.styles = [...action.payload];
      state.postProductionWipList = {
        ...state.styles,
        ...action.payload,
      };

      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getPostProdTasksFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    getPostProdCapturesSuccess(state, action) {
      logger.log("getApprovalSelects : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Get Approval Selects Success",
      };

      // state.styles = [...action.payload];
      // state.styles = {
      //   ...state.styles,
      //   ...action.payload,
      // };

      state.selectedStyle = {
        ...state.selectedStyle,
        assets: action.payload.data,
      };

      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getApprovalStyleCapturesFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    setSessionCapturesSuccess(state, action) {
      logger.log(action.type, " : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Captures successfully updated",
      };

      // update the captures
      const captures = [
        ...updateCaptureItems(state.selectedStyle.assets, action.payload),
      ];
      state.selectedStyle = { ...state.selectedStyle, assets: captures };
      state.error = null;
    },

    //////////////////////
    //
    // GET REPORT
    //
    //////////////////////
    getReportStart(state, action) {
      state.success = null;
      state.error = null;
    },
    getReportSuccess(state, action) {
      logger.log("getSchudule : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Get Styles Success" };

      // state.styles = [...action.payload];
      state.report = {
        ...state.report,
        ...action.payload,
      };

      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getReportFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    //////////////////////
    //
    // SINGLE STYLE
    //
    //////////////////////
    getStyleStart(state, action) {
      state.success = null;
      state.error = null;
    },
    getStyleSuccess(state, action) {
      logger.log("getWipSuccess : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Get Wip Success",
        data: action.payload,
      };
      // if(action.payload.urls){
      //   state.selectedProject = {...state.selectedProject, urls:action.payload.urls}
      // }
      state.selectedStyle = action.payload ? { ...action.payload } : null;
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },

    getWipAssetsSuccess(state, action) {
      logger.log("getWipSuccess : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Get Wips Assets Success" };

      state.selectedWip = { ...state.selectedWip, assets: action.payload };
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },

    getStyleFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    getWipScansSuccess(state, action) {
      logger.log("getWipScansSuccess : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Get Wip Scans Success" };

      state.selectedWip = { ...state.selectedWip, scans: action.payload };
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },

    getWipTimelineSuccess(state, action) {
      logger.log("getWipSuccess : SUCCESS");

      state.loading = false;
      state.success = {
        type: action.type,
        message: "Get Wip Timeline Success",
      };

      if (state.selectedWip) {
        state.selectedWip = {
          ...state.selectedWip,
          timeline: action.payload.Timeline,
        };
      }
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },

    updateWipAssetSuccess(state, action) {
      logger.log("updateWipSuccess : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Update Wip Success" };
      // state.selectedWip = { ...action.payload };
      state.error = null;
    },
    udpateWipAssetFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    batchUpdateWipAssetSuccess(state, action) {
      state.loading = false;
      state.success = {
        type: action.type,
        message: "Updated Wips Successfully",
      };
      // state.selectedWip = { ...action.payload };
      state.error = null;
    },

    distributeWipsSuccess(state, action) {
      logger.log("updateWipSuccess : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Update Wip Success" };

      // update the wips status for distributed items
      const tmpWips = [...state.wips].map((item) => {
        const match = action.payload.find((id) => id === item.id);
        if (match) {
          return {
            ...item,
            // status:SampleStatusTypes.SAMPLE_DISTRIBUTED
          };
        } else {
          return item;
        }
      });

      state.wips = [...tmpWips];
      state.error = null;
    },
    distributeWipsFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },

    clearNotifications(state, action) {
      state.error = null;
      state.success = null;
    },

    onServiceStart(state, action) {
      state.success = null;
      state.loading = true;
      state.error = null;
      // state.action = action.type;
    },
    onServiceFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
      state.loading = false;
    },
  },
});

// STYLES
export const fetchSchedule = (criteria,cursor,abortController, fetchAll=true,maxRequestCount) => async (dispatch) => {
  try {
    dispatch(getStylesStart());

    var tmpCursor = cursor ?? "";
    var items = [];
    if (fetchAll) {
      do {
        const data = await styleService.getSchedulePaginated(
          criteria,
          tmpCursor,
        );
        tmpCursor = data.nextCursor;
        items.push(...data.items);

        dispatch(getScheduleSuccess(new ResultSet({ items: [...items], complete: false, cursor: tmpCursor, concatItems: false }, JSON.stringify(criteria), new Date(), "schedule")));
      } while (tmpCursor);

      dispatch(getScheduleSuccess(new ResultSet({ items: [...items], complete: true, cursor: null, concatItems: false }, JSON.stringify(criteria), new Date(), "schedule")));
    } else {
      var origCursor = cursor;
      var items = [];
      var index = 0;
      var resetCursor = true;
      var tmpCursor;
      var concatItems = true;

      do {
        const data = await styleService.getSchedulePaginated(
          criteria,
          cursor,
        );
        cursor = data.nextCursor;
        items.push(...data.items);

        if (!maxRequestCount)
          dispatch(getScheduleSuccess({ items: [...items], complete: false }));

        if (maxRequestCount && maxRequestCount - 1 === index) {
          tmpCursor = cursor;
          cursor = null;
        }

        ++index;
      } while (cursor);

      if (tmpCursor) {
        const decodedString = decodeURIComponent(tmpCursor);
        // const obj = JSON.parse(decodedString);
        logger.log(decodedString);
      }

      // if(origCursor && origCursor.length && maxRequestCount){
      //   concatItems = true;
      // }

      // if(tmpCursor){
      //   concatItems = true;
      // }

      if (origCursor === "" && maxRequestCount) {
        concatItems = false;
      } else if (!maxRequestCount) {
        concatItems = false;
      }
      const tmpData = {
        items: [...items],
        complete: true,
        cursor: tmpCursor,
        concatItems: concatItems,
      };
      const result = new ResultSet(
        tmpData,
        JSON.stringify(criteria),
        new Date(),
        "schedule",
      );
      dispatch(getScheduleSuccess(result));

      // const data = await talentService.getTalentAssets(id, criteria, cursor);
      // // cursor = data.nextCursor;
      // items.push(...data.items);

      // dispatch(getTalentAssetsSuccess({ items: [...items], complete: false }));
    }

    // const currentTime = Date.now();
    // if (state.styles.data && (currentTime - state.styles.timestamp) < 3600000) {
    //   // return cachedItem.data;
    // }

    // const data = await styleService.getSchedulePaginated(criteria, cursor);
    // const result = new ResultSet(
    //   data,
    //   JSON.stringify(criteria),
    //   new Date(),
    //   "schedule",
    // );
    // dispatch(getScheduleSuccess(result));
  } catch (err) {
    logger.log("err", err);
    dispatch(getScheduleFailure(err));
  }
};

export const fetchReport = (criteria) => async (dispatch) => {
  try {
    dispatch(getReportStart());

    // const currentTime = Date.now();
    // if (state.styles.data && (currentTime - state.styles.timestamp) < 3600000) {
    //   // return cachedItem.data;
    // }

    const data = await styleService.getReport(criteria);
    const result = new ResultSet(
      data,
      JSON.stringify(criteria),
      new Date(),
      "report",
    );
    dispatch(getReportSuccess(result));
  } catch (err) {
    logger.log("err", err);
    dispatch(getReportFailure(err));
  }
};

export const fetchStyle = (id) => async (dispatch) => {
  try {
    dispatch(getStyleStart());
    // const data = await getStyleTimeline({ id: criteria.keyword });
    const data = await styleService.getStyle(id);
    dispatch(getStyleSuccess(data));
  } catch (err) {
    logger.log("err", err);
    dispatch(getStyleFailure(err));
  }
};

export const fetchStyleMeta =
  (sessionCode, styleNumber) => async (dispatch) => {
    try {
      dispatch(getStyleStart());
      // const data = await getStyleTimeline({ id: criteria.keyword });
      const data = await approvalService.getStyleMeta(sessionCode, styleNumber);
      dispatch(getStyleSuccess(data));
    } catch (err) {
      logger.log("err", err);
      dispatch(getStyleFailure(err));
    }
  };

export const fetchApprovalSelects = (criteria) => async (dispatch) => {
  try {
    dispatch(getStylesStart());

    // const currentTime = Date.now();
    // if (state.styles.data && (currentTime - state.styles.timestamp) < 3600000) {
    //   // return cachedItem.data;
    // }

    const data = await approvalService.getSelects(criteria);
    const result = new ResultSet(
      data,
      JSON.stringify(criteria),
      new Date(),
      "approvalSelects",
    );
    dispatch(getApprovalSelectsSuccess(result));
  } catch (err) {
    logger.log("err", err);
    dispatch(getApprovalSelectsFailure(err));
  }
};

export const fetchApprovalStyleCaptures = (criteria) => async (dispatch) => {
  try {
    dispatch(getStylesStart());

    // const currentTime = Date.now();
    // if (state.styles.data && (currentTime - state.styles.timestamp) < 3600000) {
    //   // return cachedItem.data;
    // }

    const data = await approvalService.getStyleCaptures(criteria);
    const result = new ResultSet(data, JSON.stringify(criteria), new Date());
    dispatch(getApprovalStyleCapturesSuccess(result));
  } catch (err) {
    logger.log("err", err);
    dispatch(getApprovalStyleCapturesFailure(err));
  }
};

export const fetchPostProductionTasks = (criteria) => async (dispatch) => {
  const data = await approvalService.getPostProductionTasks(criteria);
  const result = new ResultSet(
    data,
    JSON.stringify(criteria),
    new Date(),
    "postProductionTasks",
  );
  dispatch(getPostProdTasksFailure(result));
};

export const setSessionCaptures = (captures, user) => async (dispatch) => {
  try {
    logger.log(captures, " SETTING CAPTURES");
    dispatch(onServiceStart());
    dispatch(setSessionCapturesSuccess(captures));

    for (let i = 0; i < captures.length; i++) {
      const capture = captures[i];
      await updateCapture(capture);
    }
    //dispatch(setSessionCapturesSuccess(captures))
  } catch (err) {
    logger.log("err", err);
    dispatch(onServiceFailure(err));
  }
};

export const updateStudioSessionStyle = (style, user) => async (dispatch) => {
  try {
    logger.log(style, " SETTING STYLE");
    dispatch(onServiceStart());

    await approvalService.updateSessionStyle(style);

    //dispatch(setSessionCapturesSuccess(captures))
  } catch (err) {
    logger.log("err", err);
    dispatch(onServiceFailure(err));
  }
};

export const updateStudioSession = (session, user) => async (dispatch) => {
  try {
    dispatch(onServiceStart());

    await approvalService.updateSession(session);

    //dispatch(setSessionCapturesSuccess(captures))
  } catch (err) {
    logger.log("err", err);
    dispatch(onServiceFailure(err));
  }
};

export const {
  // selectWip,
  selectStyles,
  setWipFilter,
  setProductionWipFilter,
  setPostProductionWipFilter,
  setStyleFilter,
  setDisplayPrefs,
  setListColumns,
  selectStyle,

  styleMediaFilter,
  setStyleMediaFilter,

  getWipStart,
  getWipFailure,
  getWipSuccess,

  getWipAssetsSuccess,

  getWipScansSuccess,

  getWipTimelineSuccess,

  getStylesStart,
  getScheduleSuccess,
  getScheduleFailure,

  getApprovalSelectsSuccess,
  getApprovalSelectsFailure,

  getApprovalStyleCapturesSuccess,
  getApprovalStyleCapturesFailure,

  setSessionCapturesSuccess,

  getPostProdTasksSuccess,
  getPostProdTasksFailure,

  getReportStart,
  getReportSuccess,
  getReportFailure,

  getStyleStart,
  getStyleSuccess,
  getStyleFailure,

  getWipsStart,
  getWipsFailure,
  getWipsSuccess,

  onServiceStart,
  onServiceFailure,

  updateWipAssetSuccess,
  updateWipAssetFailure,

  batchUpdateWipAssetSuccess,

  distributeWipsSuccess,
  distributeWipsFailure,

  clearNotifications,
  setError,
} = wipSlice.actions;

export default wipSlice.reducer;
